import React from 'react';

export const ArrowDown = ({isRotate}) => {
    return (
        <svg className={`${isRotate ? '-icon-rotate' : ''}`} width="8" height="7" viewBox="0 0 8 7" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.13397 6.5C3.51887 7.16667 4.48113 7.16667 4.86603 6.5L7.4641 2C7.849 1.33333 7.36788 0.5 6.59808 0.5H1.40192C0.632124 0.5 0.150998 1.33333 0.535898 2L3.13397 6.5Z" fill="white"/>
        </svg>
    )
};
